"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUnits = exports.getUnits = exports.addUnits = void 0;

var corona_1 = require("corona");

var units_1 = require("../types/units");

function addUnits(units) {
  return {
    type: units_1.ADD_UNITS,
    units: units
  };
}

exports.addUnits = addUnits;

function getUnits(time, state) {
  return function (dispatch, getState) {
    var fields = [corona_1.Field.Location, corona_1.Field.Meter, corona_1.Field.Model
    /*, Field.Modem, Field.Connections, Field.Ports, Field.Fields, Field.Scheduling, Field.SLA*/
    ];
    /* "status:active" */

    return corona_1.get(getState().authentication, time, fields, "").then(function (units) {
      dispatch(addUnits(units));
    });
  };
}

exports.getUnits = getUnits;

function loadUnits() {
  return function (dispatch, getState) {
    return corona_1.loadFromStorage().then(function (units) {
      dispatch(addUnits(units));
    });
  };
}

exports.loadUnits = loadUnits;